import { render, staticRenderFns } from "./orderConfirm.vue?vue&type=template&id=8118ccf8&scoped=true&"
import script from "./orderConfirm.vue?vue&type=script&lang=ts&"
export * from "./orderConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./orderConfirm.vue?vue&type=style&index=0&id=8118ccf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8118ccf8",
  null
  
)

export default component.exports